import { render } from "./B2bCreateCover.vue?vue&type=template&id=28247910&scoped=true&lang=pug"
import script from "./B2bCreateCover.vue?vue&type=script&lang=js"
export * from "./B2bCreateCover.vue?vue&type=script&lang=js"

import "./B2bCreateCover.vue?vue&type=style&index=0&id=28247910&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28247910"]])

export default __exports__